<!-- ContactList.vue -->

<template>
	<div class="card componentContainer card-flush">
		<div
			class="card-header search-input"
			:class="isSizePhoneMode ? 'search-input-sm' : ''"
			id="kt_contact_contacts_header"
		>
			<form class="w-100 position-relative d-flex align-items-center gap-3" autocomplete="off">
				<div>
					<span
						class="svg-icon svg-icon-2 svg-icon-lg-1 svg-icon-gray-500 position-absolute top-50 ms-5 translate-middle-y"
					>
						<i class="bi bi-search fs-3"></i>
					</span>
					<input
						type="text"
						class="form-control form-control-solid px-15"
						name="searchField"
						autocomplete="off"
						v-model="searchTerm"
						:placeholder="$t('Find a client')"
						@input="handleSearchInput"
					/>
				</div>
				<div class="open-filter-wrapper">
                    <InlineSvg
                        :src="loadFile('filter-funnel.svg')"
                        @click="openFilterDialog"
                        class="cursor-pointer"
                    />
                </div>
                <ConversationsFiltersDialog ref="conversationsFiltersDialogRef" @applyFilters="applyFilters"/>
			</form>
		</div>
		<div
			class="card-body contact-list scroll-y"
			:class="isSizePhoneMode ? 'contact-list-sm' : ''"
			id="kt_contact_contacts_body"
			style="padding-top: 0px !important"
		>
			<ContactListItem
				:selected="selectedConversationId === contact.id"
				v-for="contact in filteredConversations"
				:key="contact.id"
				:contact="contact"
				@select-conversation="selectConversation"
				@set-active-menu="setActiveMenu"
				:activeMenu="activeMenu"
				@set-label-menu="labelActiveMenu = $event"
				:labelActiveMenu="labelActiveMenu"
				:tenant="tenant"
			/>
		</div>
	</div>
</template>

<script>
import ContactListItem from './ContactListItem.vue';
import { useLabelStore } from '@/v2/modules/whatsapp/stores/labels';
import InlineSvg from '@/v2/components/inline-svg';
import { loadFile } from '@/components/utils.js';
import ConversationsFiltersDialog from './components/ConversationsFiltersDialog';

export default {
	components: {
		ContactListItem,
		InlineSvg,
		ConversationsFiltersDialog,
	},
	props: {
		conversations: [Array, Object],
		locale: String,
		isSizePhoneMode: Boolean,
		tenant: String,
	},
	computed: {
		filteredConversations() {
			if (!this.searchTerm && !this.filters?.labels) {
				return this.conversations;
			}

			// Preprocess the search term
			let searchTermProcessed = this.searchTerm.trim().replace(/^(\+|00)+/, '');

			const searchTermLowerCase = searchTermProcessed.toLowerCase();

			return this.conversations.filter(
				(conversation) =>{
                    return ((conversation?.contact_display_name
                     ? conversation?.contact_display_name?.toLowerCase()?.includes(searchTermLowerCase)
                     : conversation.profile_name.toLowerCase().includes(searchTermLowerCase)) ||
                     conversation.whatsapp_id.toString().includes(searchTermLowerCase)) &&
                     this.checkLabelExist(conversation)
                }
			);
		},
	},
	data() {
		return {
			searchTerm: '',
			searchTimer: null,
			searchDelay: 500,
			selectedConversationId: null,
			activeMenu: null,
			labelActiveMenu: null,
			labelStore: useLabelStore(),
			loadFile,
            filters: {}
		};
	},
	beforeMount() {
		this.labelStore.fetch();
	},
	methods: {
        applyFilters(data){
            this.filters = data;
        },
	    openFilterDialog(){
            this.$refs.conversationsFiltersDialogRef.open()
        },
		setActiveMenu(e) {
			this.activeMenu = e;
		},
		handleSearchInput() {
			clearTimeout(this.searchTimer);
			this.searchTimer = setTimeout(() => {
				this.filterConversations();
			}, this.searchDelay);
		},
		filterConversations() {
			// this.filteredConversations = this.conversations.filter((conversation) => {
			// 	const profileName = conversation.profile_name
			// 		? conversation.profile_name.toLowerCase()
			// 		: '';
			// 	const contactDisplayName = conversation.contact_display_name
			// 		? conversation.contact_display_name.toLowerCase()
			// 		: '';
			// 	const searchTerm = this.searchTerm.toLowerCase();
            //
			// 	return profileName.includes(searchTerm) || contactDisplayName.includes(searchTerm);
			// });
		},
        checkLabelExist(conversation){
            let isLabelExist = false;
            if((this.filters?.labels && this.filters?.labels.length === 0) || !this.filters?.labels) isLabelExist = true;

            if(this.filters.labels){
                this.filters.labels.forEach(item=>{
                    if(conversation?.labels?.findIndex(el=> el.id == item) > -1){
                        isLabelExist = true;
                        return;
                    }
                })
            }
            return isLabelExist;
        },
		selectConversation(selectedConversation) {
			this.selectedConversationId = selectedConversation.id;
			this.$emit('select-conversation', selectedConversation);
		},
	},
	watch: {
		conversations() {
			// get conversartionId from params, in case the page is opened from order details
			const queryParams = new URLSearchParams(window.location.search);
			const conversation = queryParams.get('customerNumber');
			if (conversation) {
				const selectedConversation = this.filteredConversations.find(
					(conv) => conv.id == conversation,
				);
				if (selectedConversation) this.selectConversation(selectedConversation);
			}
		},
	},
};
</script>

<style scoped lang="scss">
@import './types/styles/chat_list.scss';
</style>
